export default {
  height: 2,
  width: 15,
  svg: `
  <rect width="15" height="2" rx="1"/>
  </svg>
  `
}

